// re.rejouis.fr : modèles « Prio » (recherchés), boost temporaire du crédit.
// Remplace les campagnes par catégorie (retirées le 2026-10-23).
//
// Posé au lab (onglet Catalogue, case Prio) sur un MODÈLE, stocké dans Shopify :
//  - metafield JSON custom.reprise_prio = { v:1, boost_pct, fin:"AAAA-MM-JJ"|null, depuis }
//    → fait foi ; lu avec le produit (mapProduit, demande.js), aucun appel au lab ;
//  - tag « Reprise prioritaire » → sert à lister les modèles (catalog ?wanted=1).
// Futur, sans changer la forme : rachat_euros:{ pct } (le client choisirait au moment
// du prix entre bon d'achat et euros, moins élevé). À lire ici, à côté du boost.
//
// Module pur et partagé : le front l'utilise pour l'affichage (pastille, prix barré),
// la fonction serveur pour le recalcul anti-triche. Les deux DOIVENT donner le même
// boost, sinon le client verrait un montant que le serveur ne servirait pas.

export const BOOST_PRIO_MAX = 1; // +100 % au plus (garde-fou si le metafield est mal saisi)

const jour = (d = new Date()) => d.toISOString().slice(0, 10);

// Valeur brute du metafield (chaîne JSON ou objet déjà lu) → objet, ou null.
export function lirePrio(valeur) {
  if (!valeur) return null;
  if (typeof valeur === 'object') return valeur;
  try { const p = JSON.parse(valeur); return p && typeof p === 'object' ? p : null; } catch { return null; }
}

/**
 * Boost Prio en cours pour un produit, en fraction du crédit (0,3 = +30 %).
 * 0 si pas Prio, réglage invalide ou date de fin dépassée (la fin est incluse).
 * @param {object} produit forme mapProduit (champ `prio`), ou { prio } côté serveur
 * @param {string} [aujourdhui] AAAA-MM-JJ (tests)
 */
export function boostPrio(produit, aujourdhui = jour()) {
  const p = lirePrio(produit?.prio);
  if (!p) return 0;
  const pct = Number(p.boost_pct);
  if (!Number.isFinite(pct) || pct <= 0) return 0;
  if (p.fin && String(p.fin).slice(0, 10) < aujourdhui) return 0;
  return Math.min(pct / 100, BOOST_PRIO_MAX);
}

/** Date de fin du boost en cours (AAAA-MM-JJ) ou null (sans fin / pas de boost). */
export function finPrio(produit) {
  const p = lirePrio(produit?.prio);
  return boostPrio(produit) > 0 && p.fin ? String(p.fin).slice(0, 10) : null;
}
